import { useNavigate } from 'react-router-dom';
import { Button } from '@/design-system/components/Button';
import { t } from '@/lib/i18n';
import styles from './NotFoundPage.module.css';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <div className={styles.code}>{t('notFound.code')}</div>
      <h1 className={styles.title}>{t('notFound.title')}</h1>
      <p className={styles.message}>{t('notFound.description')}</p>
      <Button onClick={() => navigate('/', { replace: true })}>{t('notFound.home')}</Button>
    </div>
  );
}
